import { render, staticRenderFns } from "./BaseAccountSelect.vue?vue&type=template&id=4b83ba94&scoped=true"
import script from "./BaseAccountSelect.vue?vue&type=script&lang=js"
export * from "./BaseAccountSelect.vue?vue&type=script&lang=js"
import style0 from "./BaseAccountSelect.vue?vue&type=style&index=0&id=4b83ba94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b83ba94",
  null
  
)

export default component.exports